import { configureStore } from "@reduxjs/toolkit";
// eslint-disable-next-line import/no-extraneous-dependencies
import logger from "redux-logger";

import reducer from "@slices/index";

import { IS_DEVELOPMENT } from "@constants/app-defaults";

const generateStore = configureStore({
  reducer,
  devTools: IS_DEVELOPMENT,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(IS_DEVELOPMENT ? logger : []),
});

export default generateStore;
